import React from 'react';

// DQ TAT Report (CD-5560): a Power BI report embedded as-is. Unlike the older `view?r=` (publish-to-web)
// siblings in this folder, this is a `reportEmbed?...&autoAuth=true` (secure embed) URL, so the viewer
// must be signed in to Power BI with access to the report — otherwise the frame shows a sign-in prompt.
const DQ_TAT_REPORT_URL =
  'https://app.powerbi.com/reportEmbed?reportId=d9134fb0-20e5-4648-b5af-8640d34579cb&autoAuth=true&ctid=145a5b85-93aa-4868-afa0-adedc904ec7a';

export default function DqTatReport() {
  return (
    <div className='contentwrapperiframe bg-white'>
      <iframe
        title='DQ TAT Report'
        src={DQ_TAT_REPORT_URL}
        className='report-frame'
        id='dqTatReport'
        name='dqTatReport'
        allowFullScreen
      />
    </div>
  );
}
